interface ReviewCardProps {
  username: string;
  avatar: string;
  role: string;
  rating: number;
  title: string;
  content: string;
  faded?: boolean;
}

export default function ReviewCard({
  username,
  avatar,
  role,
  rating,
  title: reviewTitle,
  content: reviewContent,
  faded,
}: ReviewCardProps) {
  return (
    <div className="bg-background-50 rounded-lg p-5 flex flex-col">
      <div className="flex items-center gap-0.5 mb-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <i
            key={i}
            className={`text-sm ${i < rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
          ></i>
        ))}
      </div>
      <h4 className="text-base font-medium text-foreground-900 mb-2">{reviewTitle}</h4>
      <p className={`text-sm leading-relaxed flex-1 ${faded ? 'text-foreground-400' : 'text-foreground-600'}`}>
        {reviewContent}
      </p>
      <div className="flex items-center gap-3 mt-4 pt-4 border-t border-background-200">
        <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
          <img src={avatar} alt={username} className="w-full h-full object-cover" loading="lazy" />
        </div>
        <div>
          <p className="text-sm font-medium text-foreground-900">{username}</p>
          <p className="text-xs text-foreground-500">{role}</p>
        </div>
      </div>
    </div>
  );
}